import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Automation from "./sections/Automation";
import Efficiency from "./sections/Efficiency";
import Ecosystem from "./sections/Ecosystem";
import Autonomy from "./sections/Autonomy";
import Impact from "./sections/Impact";
import Testimonials from "./sections/Testimonials";
import ReadyToAutomate from "./sections/ReadyToAutomate";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Automation />
      <Efficiency />
      <Ecosystem />
      <Autonomy />
      <Impact />
      <Testimonials />
      <ReadyToAutomate />
      <Footer />
    </div>;
}